import { Box, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const InputLabel = ({ text, error, children }: PropsWithChildren<{ text: string; error?: boolean }>) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      borderBottom: (theme) => `1px solid ${error ? theme.palette.error.light : theme.palette.divider}`,
    }}
  >
    <Typography variant="body2" color={(theme) => (error ? theme.palette.error.light : theme.palette.disabled.main)}>
      {text}:
    </Typography>
    {children}
  </Box>
);
